import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'

import LoggedInToolBar from './LoggedInToolBar'
import NotLoggedInToolBar from './NotLoggedInToolBar'

import { navLinks, TUTOR_ROLE } from '../../constants/global'
import {
  selectAccessToken,
  selectRole,
  selectUserData,
} from '../../routing/fetchingfunction/user/user.reducer'
import LanguageSelect from './NotLoggedInToolBar/LanguageSelect'

const UserNavbar = () => {
  //const theme = useTheme()
  //const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const role = useSelector(selectRole)
  const accessToken = useSelector(selectAccessToken)
  const userData = useSelector(selectUserData)

  // Consider a user logged in only if they have both an access token and user data
  const isLoggedIn =
    !!accessToken && !!userData && accessToken !== 'undefined' && accessToken !== 'null'

  const navLinksList = navLinks(role === TUTOR_ROLE, isLoggedIn)

  return (
    <>
      {/* Full width navbar container */}
      <Box
        sx={{
          width: '100vw',
          position: 'relative',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          backgroundColor: 'white',
          borderBottom: '1px solid #e0e0e0',
          zIndex: 1000,
        }}
      >
        {/* Content wrapper */}
        <Box
          sx={{
            maxWidth: '1440px',
            margin: '0 auto',
            paddingX: { xs: '16px', sm: '24px', md: '32px', lg: '48px' },
            height: { xs: '64px', md: '80px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* Left side - Logo and Navigation */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: '20px', md: '48px' },
              flex: 1,
            }}
          >
            {/* Logo */}
            <Link
              to={isLoggedIn ? `/${role || 'student'}` : '/'}
              style={{ textDecoration: 'none' }}
            >
              <Box
                component="img"
                src="/assets/image/apoloLogoImg.svg"
                alt="APOLO Logo"
                sx={{
                  height: { xs: '36px', md: '48px' },
                  width: { xs: '108px', md: '135px' },
                }}
              />
            </Link>
          </Box>

          {/* Right side - Action buttons and language selector */}
          <Box className="flex items-center gap-4">
            {/* Navigation Links */}
            <Box component="nav" aria-label="Main navigation">
              <Box
                component="ul"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: '16px', md: '32px' },
                  listStyle: 'none',
                  margin: 0,
                  padding: 0,
                }}
              >
                {/* Dynamic navigation links from your navLinks function */}
                {/* {navLinksList.map((navLink) =>
                  navLink.isVisible ? (
                    <Box component="li" key={navLink.href}>
                      <Link
                        to={navLink.href}
                        style={{
                          textDecoration: 'none',
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#ff6b35',
                            fontSize: { xs: '14px', md: '16px' },
                            fontWeight: 500,
                            '&:hover': {
                              color: '#e55a2b',
                            },
                          }}
                        >
                          {navLink.label}
                        </Typography>
                      </Link>
                    </Box>
                  ) : null
                )} */}
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {isLoggedIn ? <LoggedInToolBar /> : <NotLoggedInToolBar />}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default UserNavbar
